import styled, { keyframes, css } from 'styled-components';

interface ContainerProps {
  navHeight?: number;
}

export const Container = styled.div<ContainerProps>`
  background-color: var(--white);
  padding-top: ${props => props.navHeight ? `${props.navHeight}px` : '0'};
`;

interface ContainerNavProps {
  isFixed?: boolean;
}

export const ContainerNav = styled.div<ContainerNavProps>`
  position: ${props => props.isFixed ? 'fixed' : 'relative'};
  top: ${props => props.isFixed ? '0' : 'auto'};
  left: ${props => props.isFixed ? '0' : 'auto'};
  width: 100%;
  z-index: ${props => props.isFixed ? '1100' : 'auto'};
  background-color: var(--white);
`;

export const RootModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;

  width: 100%;
  height: 100vh;
`;

export const ContainerModal = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;

  background: rgba(0, 0, 0, 0.51);
  z-index: 400;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const BottonModalClose = styled.div`
  width: 20px;
`;

interface ModalProps {
  parameter?: ModalContentProps;
}

export interface ModalContentProps {
  width?: string;
  height?: string;
  buttonClose?: boolean;
  top?: string;
}

const appearFronBackgroud = keyframes`
  from {
    opacity: 0;
    background-color: #fff;
    border: 1px solid #ccc;

  }
  to {
    opacity: 1;
    border: none;
  }
`;

export const ModalContent = styled.div<ModalProps>`
  position: absolute;
  top: 0;
  width: 100%;
  max-width: 750px;
  height: 100%;
  padding: 0 2%;
  overflow-x: scroll;

  ${props =>
    props.parameter &&
    props.parameter.height &&
    css`
      height: ${props.parameter.height};
    `}

  ${props =>
    props.parameter &&
    props.parameter.top &&
    css`
      top: ${props.parameter.top};
    `}
  > button {
    position: absolute;
    top: 15px;
    left: 85%;
    cursor: pointer;
  }

  background: #fff;
  animation: ${appearFronBackgroud} 1s ease-out;

  z-index: 500;

  border-radius: 10px;

  color: var(--gray);
`;

export const ContainerFooter = styled.div`
  height: 50px;
  width: 100%;
`;
